/**
 * Server-Authoritative Game State Types
 *
 * Shared types for dice phase tracking and state synchronization
 * between server and clients.
 */
// ============================================================================
// DICE PHASE TRACKING
// ============================================================================
/**
 * Dice phase tracking (within roll states)
 * Server tracks this for each active roller
 */
export var DicePhase;
(function (DicePhase) {
    DicePhase["IDLE"] = "idle";
    DicePhase["COLLECTING"] = "collecting";
    DicePhase["HOLDING"] = "holding";
    DicePhase["THROWN"] = "thrown";
    DicePhase["SETTLING"] = "settling";
    DicePhase["STOPPED"] = "stopped";
})(DicePhase || (DicePhase = {}));
//# sourceMappingURL=GameState.js.map